import { Box } from '@mui/material';

/** Follow-up questions revealed by an earlier answer — the wireframes' teal left rule. */
export default function ConditionalBranch({ children }) {
  return (
    <Box
      sx={{
        borderLeft: 2,
        borderColor: 'primary.main',
        pl: 2,
        ml: 1,
        py: 0.25,
        display: 'flex',
        flexDirection: 'column',
        gap: 2.5,
      }}
    >
      {children}
    </Box>
  );
}
